import { Component, OnInit, Output, EventEmitter, HostListener} from '@angular/core';
import { CompleterService, RemoteData, CompleterItem } from 'ng2-completer';
import { Http, Response } from "@angular/http";
import { SuggestAutocompleteDataService } from './SuggestAutocompleteDataService';
import { SearchService } from '../../services/search/search.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

    @Output() private selectedCandidate = new EventEmitter<Object>();
    @Output() private hasActivatedResponsive = new EventEmitter<boolean>();

    public customData: SuggestAutocompleteDataService = null;
    protected strABuscar: String;
    private iconURLBase: String;
    private urlServerBase: String;
    private config: any;
    private categoriesIcon: any;
    private responsiveSearchActive: boolean = false;
    constructor(completerService: CompleterService, private searchService: SearchService, http: Http) {
        if (this.searchService.getConfigurationSaved() != null) {
            this.config = this.searchService.getConfigurationSaved();
        }
        this.config = this.searchService.getConfigurationFromUrl().then(
            data => {
                this.categoriesIcon = data['autocomplete']['categoriessuggest'];
                this.iconURLBase = data['autocomplete']['pathIcon'];
                this.urlServerBase = data['autocomplete']['urlServer'];
                this.customData = new SuggestAutocompleteDataService(http, this.categoriesIcon, this.iconURLBase, this.urlServerBase);
            },
            error => {
                console.error("S'ha produït un error en inicialitzaar el component search: " + error);
            });
    }

    ngOnInit() {

    }

    protected onSelected(item: CompleterItem) {
        if (item && item.originalObject) {
            console.log(item.originalObject);
            this.selectedCandidate.emit(item.originalObject);
        }
    }


    public toggleResponsive() {
        this.responsiveSearchActive = !this.responsiveSearchActive;
        this.hasActivatedResponsive.emit(this.responsiveSearchActive);
    }


    /*
    * Escoltem l'event de resize de les finestres, per ajustar el mapa a la vista.
    */
    @HostListener('window:resize', ['$event'])
    public onResize(event) {
        console.debug(">>> MapComponent: onResize");
        // establir l'alçada dels panells i del mapa
        let isSmall = window.innerWidth <= 768;
        this.responsiveSearchActive = isSmall && this.responsiveSearchActive;
        this.hasActivatedResponsive.emit(this.responsiveSearchActive);
    }

}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/search/search.component.ts